var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-flashing-dot animation-flashing _inline-block _rounded-full _bg-current _ml-5 _mr-5",class:[_vm.clss]})}
var staticRenderFns = []

export { render, staticRenderFns }